export function processingFeeDollars(subtotalCents, rate) {
  return Math.round(subtotalCents * rate) / 100;
}
